import { create } from 'zustand';

interface Branch {
  id: string;
  name: string;
  location?: string;
  isDefault: boolean;
}

interface BranchStore {
  activeBranch: Branch | null;
  setActiveBranch: (branch: Branch | null) => void;
}

export const useBranchStore = create<BranchStore>((set) => ({
  activeBranch: null,
  setActiveBranch: (branch) => set({ activeBranch: branch }),
}));
